export default __webpack_public_path__ + "e79d6f1e0a2d31c420974ca5325f410c.svg";